import PlainToggle, { type PlainToggleProps } from './plain-toggle'
import PlainToggleExtendedLabel, { type PlainToggleExtendedProps } from './plain-toggle-extended-label'


export default PlainToggle
export { PlainToggleExtendedLabel }
export type { PlainToggleProps, PlainToggleExtendedProps }
